module.exports = __webpack_public_path__ + "img/lock.4abe2c16.png";